// extracted by mini-css-extract-plugin
export default {"modalContainer":"ThankYouWindow_modalContainer__7iOIK","mainText":"ThankYouWindow_mainText__RKT-m","secondTetx":"ThankYouWindow_secondTetx__-IVmY"};